import React, { FunctionComponent } from 'react';
import { SumInsuredContentsValueStep as CommonSumInsuredContentsValueStep } from 'scenes/common/components/Steps';

import { HomeFullPageProps } from 'scenes/home/types';
import { getContentsSumInsured } from 'scenes/home/selectors';

const modalHelpText =
  'Contents items include furniture and furnishings, internal blinds and curtains, household electrical appliances such as refrigerators, televisions, kitchen and table ware, clothing and personal items.';

const helpText =
  "Be sure to include everything in your total, even special items like rings, watches and jewellery. We'll get the details of these special items later, if you decide to buy the policy.";

const SumInsuredContentsStep: FunctionComponent<HomeFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <CommonSumInsuredContentsValueStep
    onNext={onNext}
    defaultStateValue={getContentsSumInsured(funnelState)}
    valueRange={{ lowerLimit: '25000', upperLimit: '500000' }}
    modalHelpText={modalHelpText}
    helpText={helpText}
  />
);

export default SumInsuredContentsStep;
